import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import classNames from 'classnames';
import React from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

import Button from '../buttons/button';

import styles from './editableFieldArray.module.scss';

type EditableFieldArrayOwnProps = {
  fields: any;
  newField: () => any;
  indexName: string;
  fieldName: string;
  errors?: any;
  subFields: any;
  readonly?: boolean;
};

type EditableFieldArrayInnerStateProps = {
  selectedIndex: number;
};

export default class EditableFieldArray extends React.Component<
  EditableFieldArrayOwnProps,
  EditableFieldArrayInnerStateProps
> {
  constructor(props: EditableFieldArrayOwnProps) {
    super(props);
    this.state = {
      selectedIndex: 0,
    };
  }

  private addField = () => {
    const { fields, newField } = this.props;
    fields.push(newField());
    this.setState({
      selectedIndex: fields.length,
    });
  };

  private onTabSelect = (tabIndex: number) => {
    this.setState({
      selectedIndex: tabIndex,
    });
  };

  private removeField = (index: number) => () => {
    const { fields } = this.props;
    fields.remove(index);
    this.setState({
      selectedIndex: index > 0 ? index - 1 : 0,
    });
  };

  public render() {
    const { readonly, fieldName, fields, errors, subFields } = this.props;
    const { selectedIndex } = this.state;

    return (
      <>
        {!readonly && (
          <Button
            onClick={this.addField}
            text={`Add ${fieldName}`}
            icon={faPlus}
            className={styles.addOverlayButton}
            type="button"
            slimButton
          />
        )}
        <Tabs
          className={styles.configTabs}
          selectedTabClassName={styles.selectedTab}
          selectedIndex={selectedIndex}
          onSelect={this.onTabSelect}
        >
          <TabList className={styles.configTabList}>
            {fields.map((overlay: string, index: number) => {
              const hasError = errors && errors[index];
              const field = fields.get(index);

              return (
                <Tab
                  className={classNames(styles.fieldArrayTab, {
                    [styles.error]: hasError,
                  })}
                  key={overlay}
                >
                  {field?.name ?? `${fieldName} ${index + 1}`}
                </Tab>
              );
            })}
          </TabList>
          {fields.map((overlay: string, index: any) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <TabPanel className={styles.configTabPanel} key={overlay} forceRender>
                {subFields(overlay, index)}
                {!readonly && (
                  <Button
                    onClick={this.removeField(index)}
                    text={`Remove ${fieldName}`}
                    icon={faTimes}
                    className={styles.addOverlayButton}
                    type="button"
                    slimButton
                  />
                )}
              </TabPanel>
            );
          })}
        </Tabs>
      </>
    );
  }
}
